import { AxiosResponse } from 'axios';

import { AxiosAccessTokenClientBearer, AxiosClient } from '@hcs/http-clients';
import {
  MlsRegistrationRequest,
  MlsRegistrationResponse,
  SamlapiDestinationResponseExt,
  SamlapiLoginLinkRespExt,
  SelfserveapiSendBrokerOfficeApprovalEmailRequest,
  SelfserveapiSendBrokerOfficeApprovalEmailResponse,
} from '@hcs/types';
import { ACCOUNT_URL, ACCOUNT_URL_EXTERNAL } from '@hcs/urls';

export const AccountApi = {
  sendSsoLoginLinkEmail: async ({
    email,
    url,
  }: {
    email: string;
    url?: string;
  }) => {
    const response = await AxiosClient.post<SamlapiLoginLinkRespExt>(
      `${ACCOUNT_URL_EXTERNAL}/saml/login-link?url=${url}`,
      {
        email,
      },
    );
    return response.data;
  },
  fetchOrgLoginDestination: async ({
    orgSlug,
    destinationUrl,
  }: {
    orgSlug: string;
    destinationUrl?: string;
  }) => {
    const response = await AxiosClient.get<SamlapiDestinationResponseExt>(
      `${ACCOUNT_URL_EXTERNAL}/saml/${orgSlug}/destination?url=${destinationUrl}`,
    );
    return response.data;
  },
  linkSponsorAccount: async ({ nonce }: { nonce: string }) => {
    const response = await AxiosClient.post<{
      message: string;
      sponsorName: string;
      email: string;
    }>(`${ACCOUNT_URL_EXTERNAL}/sponsor/confirm-conversion`, {
      nonce,
    });
    return response.data;
  },
  registerAgentForMls: async (payload: MlsRegistrationRequest) => {
    const response = await AxiosAccessTokenClientBearer.post<
      MlsRegistrationResponse,
      AxiosResponse<MlsRegistrationResponse>,
      MlsRegistrationRequest
    >(`${ACCOUNT_URL}/agents/mls-registration`, payload);
    return response.data;
  },
  sendBrokerApprovalEmail: async (
    payload: SelfserveapiSendBrokerOfficeApprovalEmailRequest,
  ) => {
    const response = await AxiosAccessTokenClientBearer.post<
      SelfserveapiSendBrokerOfficeApprovalEmailResponse,
      AxiosResponse<SelfserveapiSendBrokerOfficeApprovalEmailResponse>,
      SelfserveapiSendBrokerOfficeApprovalEmailRequest
    >(`${ACCOUNT_URL}/broker-offices/send-approval-email`, payload);
    return response.data;
  },
};
